// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__d3gd3","head":"Table_head__15uYJ","col":"Table_col__1OA6M"};